export const environment = {
  production: true,
  loggingLevel: 4,
  environmentName: 'prod',
  version: '',
  laasPortalUrl: 'https://iservice.laasholdings.com',
  apiKey: '33c1b6ffa520467ead48e172308e6274',
  b2bApiUrl: 'https://api.laasholdings.com/laas-b2b/v1/b2b',
  logisticsApiUrl: 'https://api.laasholdings.com/laas-logistics/v1/logistics',
  notificationUrl: 'https://api.laasholdings.com/laas-notifications/v1/notifications',
  whOutboundApiUrl: 'https://api.laasholdings.com/laas-wh-outbound/v1/wh-outbound',
  dmUrl: 'https://api.laasholdings.com/laas-dm/v1/dm',
  authUrl: 'https://api.laasholdings.com/laas-auth/v1/auth',
  clientId: '3c094d33-ec96-4923-940a-6ea7d1abf8d8',
  aiUrl: 'https://api.laasholdings.com/ai',
  authority: 'https://login.microsoftonline.com/common',
  redirectUrl: 'https://iservice.laasholdings.com/AzureAd',
  dashboardUrl: 'http://65.52.181.81',
  expenseApiUrl: 'https://api.laasholdings.com/laas-expense/v1/expense',
  wpgApiUrl: 'https://api.laasholdings.com/laas-wpg/v1/wpg',
  customerserviceApiUrl: 'https://api.laasholdings.com/laas-customer-service/v1/customerservice',
  apmServerUrl: 'https://51af18f0d7a54c058bf13c00fea9258b.apm.southeastasia.azure.elastic-cloud.com:443',
  apmSecretToken: '3bsPaWboc0vs39PRCK',
  iamUrl: 'https://iservice.laasholdings.com/iam',
  laasPlatformBaseUrl: 'https://iservice.laasholdings.com/platform',
  laasLegacyFramePluginPath: 'legacyMenu',
};
